export default __webpack_public_path__ + "static/media/woman.93570246.png";